module.exports = __webpack_public_path__ + "static/media/club-tarjeta.0759080c.png";